import { Grid, Text } from '@mantine/core';
import { IconTarget } from '@tabler/icons-react';
import { useParams } from 'react-router';
import HeaderStatistic from '../HeaderStatistic';
import LazyLoadSpinner from '../LazyLoaderSpinner';

const CampaignsStats = ({ campaign, stats, period, currency }) => {
  const { accountId, domainId } = useParams();
  const segmentLink = (preset) => {
    return `#/accounts/${accountId}/domains/${domainId}/segments/new?preset=${preset}&id=${campaign.id}&startDate=${period.startDate}&endDate=${period.endDate}`;
  };

  const statsValue = (stat, id, key) => {
    return ((stats[stat] || {})[id.toString()] || {})[key] || 0;
  };

  if (!stats) {
    return (
      <Grid justify="center">
        <LazyLoadSpinner />
      </Grid>
    );
  }

  const goals = campaign.goals || [];

  const goalTiles = goals.map((goal, idx) => {
    const count = statsValue(goal.name, campaign.id, 'count').toLocaleString(navigator.language, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
    const value = goal.trackRevenue
      ? statsValue(goal.name, campaign.id, 'value').toLocaleString(navigator.language, {
          style: 'currency',
          currency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        })
      : undefined;

    return (
      <Grid.Col key={goal.id ?? `${goal.name}-${idx}`} span="auto" ta="center">
        <Text size="sm" c="dimmed">
          <IconTarget size={14} /> {goal.name}
        </Text>
        <Text fw={600}>
          {count}
          {value !== undefined && (
            <Text component="span" c="dimmed" fw={400}>
              {' '}| {value}
            </Text>
          )}
        </Text>
      </Grid.Col>
    );
  });

  return (
    <Grid>
      <Grid.Col span="auto" ta="center">
        <HeaderStatistic title="Sent" stats={stats} stat="sent" id={campaign.id} statKey="count" />
      </Grid.Col>
      <Grid.Col span="auto" ta="center">
        <HeaderStatistic
          title="Delivered"
          stats={stats}
          percentageOfStat="sent"
          stat="deliveries"
          id={campaign.id}
          statKey="count"
        />
      </Grid.Col>
      <Grid.Col span="auto" ta="center">
        <HeaderStatistic
          title="Clicks"
          stats={stats}
          stat="clicks"
          percentageOfStat="deliveries"
          id={campaign.id}
          statKey="count"
        />
      </Grid.Col>
      {goalTiles}

      <Grid.Col span="auto" ta="center" style={{ borderLeft: '1px dotted' }}>
        <HeaderStatistic
          title="Bounces"
          stats={stats}
          stat="bounces"
          link={segmentLink('emailBounceForCampaign')}
          id={campaign.id}
          percentageOfStat="sent"
          statKey="count"
        />
      </Grid.Col>
      <Grid.Col span="auto" ta="center">
        <HeaderStatistic
          title="Unsubscribes"
          stats={stats}
          stat="unsubscribes"
          id={campaign.id}
          percentageOfStat="sent"
          statKey="count"
        />
      </Grid.Col>
    </Grid>
  );
};

export default CampaignsStats;
